import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../core/i18n'
import { remindMailTemplateService } from '../../core/services'
import * as constants from '../../static/constants'
import * as interfaces from '../../static/interfaces'
import { InputText, InputTextArea, Toggle, Button } from '../atoms'
import { Form } from '../molecules'

declare var window: interfaces.IWindow

interface IProps {
  mail_template: any
  post_id: number
  user: interfaces.IUser
}

interface IErrors {
  [key: string]: string | null
}
const PostRemindMailTemplate: React.FC<IProps> = props => {
  const [isSubmitEnabled, setSubmitEnabled] = React.useState<boolean>(false)
  const [errors, setErrors] = React.useState<IErrors>({})
  const [localValue, setLocalValue] = React.useState(null)
  const handleUpdateForm = (updatedErrors, updatedIsSubmitEnabled, values) => {
    setErrors(updatedErrors)
    setSubmitEnabled(updatedIsSubmitEnabled)
    setLocalValue(values)
  }

  const handleSubmitForm = async (initialValues, values) => {
    const { flush } = await remindMailTemplateService.createOrUpdate(props.post_id, {
      remind_mail_template: values,
    })
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
  }

  const FIELDS = {
    first_send_days_before: 'first_send_days_before',
    second_send_days_before: 'second_send_days_before',
    send_to_agent: 'send_to_agent',
    send_to_guide: 'send_to_guide',
    send_to_guest: 'send_to_guest',
    agent_text: 'agent_text',
    guide_text: 'guide_text',
    guest_text: 'guest_text',
  }

  const data = props.mail_template || {}

  return (
    <>
      <h2 className="Editor_Title">{I18n.t('activerecord.models.remind_mail_template')}</h2>
      <Form fields={FIELDS} handleUpdateForm={handleUpdateForm} handleSubmit={handleSubmitForm}>
        <FormItem>
          <Toggle
            name="send_to_guest"
            label={I18n.t('activerecord.attributes.remind_mail_template.send_to_guest')}
            defaultChecked={data.send_to_guest}
          />
        </FormItem>
        <FormItem>
          <InputTextArea
            name="guest_text"
            label={I18n.t('activerecord.attributes.remind_mail_template.guest_text')}
            error={errors.guest_text}
            defaultValue={data.guest_text}
          />
        </FormItem>
        <FormItem>
          <Toggle
            name="send_to_guide"
            label={I18n.t('activerecord.attributes.remind_mail_template.send_to_guide')}
            defaultChecked={data.send_to_guide}
          />
        </FormItem>
        <FormItem>
          <InputTextArea
            name="guide_text"
            label={I18n.t('activerecord.attributes.remind_mail_template.guide_text')}
            error={errors.guide_text}
            defaultValue={data.guide_text}
          />
        </FormItem>
        <FormItem hide={props.user.guide}>
          <Toggle
            name="send_to_agent"
            label={I18n.t('activerecord.attributes.remind_mail_template.send_to_agent')}
            defaultChecked={data.send_to_agent}
          />
        </FormItem>
        <FormItem hide={props.user.guide}>
          <InputTextArea
            name="agent_text"
            label={I18n.t('activerecord.attributes.remind_mail_template.agent_text')}
            error={errors.agent_text}
            defaultValue={data.agent_text}
          />
        </FormItem>
        <FormItem>
          <InputText
            required={true}
            name="first_send_days_before"
            label={I18n.t('activerecord.attributes.remind_mail_template.first_send_days_before')}
            error={errors.first_send_days_before}
            defaultValue={data.first_send_days_before}
          />
        </FormItem>
        <FormItem>
          <InputText
            name="second_send_days_before"
            label={I18n.t('activerecord.attributes.remind_mail_template.second_send_days_before')}
            error={errors.second_send_days_before}
            defaultValue={data.second_send_days_before}
          />
        </FormItem>
        <VariableDescription>
          {I18n.t('activerecord.attributes.remind_mail_template.available_variables')}
          <br />
          {I18n.t('activerecord.attributes.remind_mail_template.guest_name')}
          <br />
          {I18n.t('activerecord.attributes.remind_mail_template.tour_date')}
          <br />
        </VariableDescription>
        <div className="Editor_Footer">
          <Button primary={true} disabled={!isSubmitEnabled}>
            {I18n.t('generic.update')}
          </Button>
        </div>
      </Form>
    </>
  )
}

const FormItem = styled.div`
  ${({ hide }) => hide && 'display: none'}
  & + & {
    margin-top: 16px;
  }
`
const VariableDescription = styled.div`
  margin-left: 240px;
  font-size: 14px;
  margin-top: 5px;
`

const Field = styled.div`
  display: flex;
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    flex-direction: column;
  }

  & + & {
    margin-top: 24px;
    padding-top: 20px;
    border-top: solid 1px ${constants.COLORS.divider};
  }

  > label {
    width: 200px;
    font-weight: bold;
  }

  > div {
    flex: 1;
  }

  a {
    color: ${constants.COLORS.primary};
    display: inline-block;
    margin-top: 4px;
    font-size: 14px;
    cursor: pointer;
  }
`

export default PostRemindMailTemplate
